// packages/api-client/queries/scoresheetSchemas/index.ts
import { useQuery, useMutation, } from "@tanstack/react-query";
export const createScoresheetSchemasQueries = (requests, queryClient) => ({
    useListScoresheetSchemas: (params, options = {}) => useQuery({
        queryKey: ["scoresheet-schemas", params],
        queryFn: async ({ queryKey }) => {
            const [_key, params] = queryKey;
            return requests.listScoresheetSchemas(params);
        },
        ...options,
    }),
    useFindScoresheetSchema: (params, options = {}) => useQuery({
        queryKey: ["scoresheet-schema", params],
        queryFn: async ({ queryKey }) => {
            const [_key, params] = queryKey;
            return requests.findScoresheetSchema(params);
        },
        ...options,
    }),
    useCreateScoresheetSchema: (options = {}) => useMutation({
        ...options,
        mutationFn: (scoresheetSchemaAttrs) => {
            return requests.createScoresheetSchema(scoresheetSchemaAttrs);
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["scoresheet-schemas"] });
            options.onSuccess?.(null, null, null);
        },
    }),
    useUpdateScoresheetSchema: (options = {}) => useMutation({
        ...options,
        mutationFn: (scoresheetSchemaAttrs) => {
            return requests.updateScoresheetSchema(scoresheetSchemaAttrs);
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["scoresheet-schemas"] });
            options.onSuccess?.(null, null, null);
        },
    }),
});
//# sourceMappingURL=index.js.map